import styled from "styled-components";

export const AppWrapper = styled.div`
  min-height: 100vh;
  padding: 20px;
`;

export const Container = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`;

export const Title = styled.h1`
  font-family: "Viga", sans-serif;
  font-weight: 500;
  font-size: 28px;
  margin-bottom: 15px;
`;
